export const EntityTypes = {
  Default: 0,
  Units: 1,
  Ports: 2,
  Vids: 3,
  Services: 4,
  GuiZones: 5,
};

export const EntityTypeStrings = {
  0: 'Entity',
  1: 'Unit',
  2: 'Port',
  3: 'VID',
  4: 'Service',
  5: 'GUI Zone',
};

export const ItemFieldNames = {
  0: 'none',
  1: 'units',
  2: 'ports',
  3: 'vids',
  4: 'services',
  5: 'gui_zones',
};

export const LinkedEntitiesModalTypes = {
  Add: 0,
  Delete: 1,
};

interface LinkedEntity {
  href: string;
  label: string;
}

interface LinkedEntitiesLinks {
  self: {
    href: string;
  };
  model: {
    href: string;
  };
  evid_function: {
    href: string;
    label: string;
  };
  units?: LinkedEntity[];
  ports?: LinkedEntity[];
  vids?: any[];
  services?: any[];
  gui_zones?: any[];
}

export interface LinkedUnits {
  _links: LinkedEntitiesLinks;
  id: number;
  key: string;
  allowed_unit_models?: any[];
  only_one_entity: boolean;
}

export interface LinkedPorts {
  _links: LinkedEntitiesLinks;
  id: number;
  key: string;
  allowed_port_models?: any[];
  only_one_entity: boolean;
}

export interface LinkedVids {
  _links: LinkedEntitiesLinks;
  id: number;
  key: string;
  allowed_vid_models?: any[];
  only_one_entity: boolean;
}

export interface LinkedServices {
  _links: LinkedEntitiesLinks;
  id: number;
  key: string;
  allowed_service_models?: any[];
  only_one_entity: boolean;
}

export interface LinkedGuiZones {
  _links: LinkedEntitiesLinks;
  id: number;
  key: string;
  allowed_service_models?: any[];
  only_one_entity: boolean;
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/models/linked-entities/types.ts